/**
 * Enum for arrow css classes
 *
 * Format is ANGLE_DIRECTION_ALIGNMENT
 */
export enum CrosswordArrowClassesEnum {
  NorthRight = 'swedish-arrow-north-right',
  NorthEastRight = 'swedish-arrow-north-east-right',
  WestDown = 'swedish-arrow-west-down',
  EastDown = 'swedish-arrow-east-down',
  EastRightDown = 'swedish-arrow-east-right-center',
  EastRightTop = 'swedish-arrow-east-right-top',
  SouthDown = 'swedish-arrow-south-down',
  SouthWestDown = 'swedish-arrow-south-west-down',
  SouthRight = 'swedish-arrow-south-right',
  SouthEastDown = 'swedish-arrow-south-east-down',
  SouthEastRight = 'swedish-arrow-south-east-right',
  EastRightBottom = 'swedish-arrow-east-right-bottom',
}
